/**
 * Expose jQuery as window.jQuery/window.$ for legacy plugins (e.g. fancybox)
 * and in-house modules that expect a global $, replacing the old
 * webpack expose-loader rule removed when the build moved to Vite.
 */
import $ from "jquery"

window.jQuery = window.$ = $
